<onyx-modal
  variant="right"
  [heading]="order() ? `${order()!.identifier}` : undefined"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="order$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container titleLeftOptions>
    @if (order()?.parameters; as parameters) {
      <onyx-icon
        [name]="parameters.isDedicated ? 'ftl-outlined' : 'ltl-outlined'"
        [size]="20"
        [onyxTooltip]="parameters.isDedicated ? 'FTL' : 'LTL'"
      ></onyx-icon>
    }
  </ng-container>

  <ng-container headingButtons>
    @if (order()) {
      @if (hasShowOnMap()) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="map-view-outlined"
          [circle]="true"
          onyxTooltip="labels.showOnMap"
          (click)="showOnMap()"
        ></onyx-icon-button>

        @if (!isInactive()) {
          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="32"
            icon="gantt-outlined"
            [circle]="true"
            onyxTooltip="labels.showOnGantt"
            (click)="showOnGantt()"
          ></onyx-icon-button>
        }
      }

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="share-outlined"
        [circle]="true"
        onyxTooltip="labels.share"
        (click)="share()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="options-vertical-filled"
        [circle]="true"
        [onyxDropdownOptions]="options()"
        [onyxDropdownDisabled]="!options()?.length"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        onyxTooltip="labels.options"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>
    }
  </ng-container>

  <ng-container titleRightOptions>
    @if (order(); as order) {
      <div class="f-muted" style="display: contents">
        @let parameters = order.parameters;
        @if (parameters.sentNotificationNumber; as sentNotificationNumber) {
          <onyx-icon
            name="sent-filled"
            [size]="20"
            [onyxTooltip]="
              'labels.sentNotificationNumber'
                | translate: { number: sentNotificationNumber }
            "
          ></onyx-icon>
        }

        @if (parameters.hasSafeParking) {
          <onyx-icon
            name="safe-parking-filled"
            [size]="20"
            onyxTooltip="labels.hasSafeParking"
          ></onyx-icon>
        }

        @if (parameters.isExclusive) {
          <onyx-icon
            name="exclusive-filled"
            [size]="20"
            [onyxTooltip]="`${I18N}.exclusive`"
          ></onyx-icon>
        }
      </div>
    }
  </ng-container>

  <ng-container description>
    @if (order(); as order) {
      <app-order-modal-header-description
        [order]="order"
      ></app-order-modal-header-description>
    }
  </ng-container>

  @if (order()) {
    <onyx-chips
      sectionChips
      [chips]="sections()"
      variant="tertiary"
      [single]="true"
      [wrap]="true"
      [gap]="8"
      [(activeValues)]="section"
    ></onyx-chips>
  }

  <section>
    @if (order(); as order) {
      <div class="container">
        @switch (section()[0]) {
          @case (OrderModalSection.SUMMARY) {
            <app-order-modal-statuses
              [order]="order"
              [close$]="close$"
            ></app-order-modal-statuses>

            <app-order-modal-summary
              [order]="order"
              [close$]="close$"
              [isInactive]="isInactive()"
              [mode]="data.planningMode"
            ></app-order-modal-summary>
          }
          @case (OrderModalSection.ROUTE) {
            <app-order-modal-route
              [order]="order"
              [close$]="close$"
            ></app-order-modal-route>
          }
          @case (OrderModalSection.DOCUMENTS) {
            <app-order-modal-documents
              [order]="order"
              [close$]="close$"
            ></app-order-modal-documents>
          }
          @case (OrderModalSection.DETAILS) {
            <app-order-modal-details [order]="order"></app-order-modal-details>
          }
          @case (OrderModalSection.NOTE) {
            <app-modal-note
              [note]="order.note"
              [route]="OrdersRoute.EDIT_ORDER.replace(':uuid', order.uuid)"
              [close$]="close$"
            ></app-modal-note>

            @let outsourcingNote = order.outsourcingData?.note;
            @if (outsourcingNote && outsourcingNote.content) {
              <app-modal-note
                heading="orders.orderModal.outsourcingNote"
                [note]="outsourcingNote"
                [close$]="close$"
              ></app-modal-note>
            }
          }
        }
      </div>
    }
  </section>
</onyx-modal>
